import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import * as Reqst from '../../utils/Reqst';
import Sanitize from '../../utils/Sanitize';
import RenderMenu from './rendermenu';
import { Nav, Navbar, NavDropdown, NavItem, Modal } from 'react-bootstrap';
import swal from 'sweetalert';

import LOGO from '../../assets/img/tdtatirunelveli.png';

const acYearBtn = {
	backgroundColor: '#17a2b8',
	color: '#fff',
	border: '1px solid #17a2b8',
	margin: '0px',
	padding: '9px 8px',
	lineHeight: '0px'
}

const rightIcon = {
	fontSize: '16px'
}

class Header extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loginId: Sanitize.getData('labUser_id'),
			companyId: Sanitize.getData('labUser_clientid'),
			masterId: Sanitize.getData('labUser_masterid'),
			acyearId: Sanitize.getData('AcYear_id'),
			acyearName: Sanitize.getData('AcYear_name'),
			showLoader: false,
			isRedirect: false,
			acYearList: [],
			showAcYearModal: false,
		}
		this.handleLogout = this.handleLogout.bind(this);
	}

	componentDidMount() {

	}

	handleLogout() {
		swal({
			title: 'Confirm',
			text: 'Do you want to Logout?',
			buttons: ['No', 'Yes']
		}).then((willYes) => {
			if (willYes) {
				var rol = [];
				rol.push({ nme: 'tes' });
				localStorage.removeItem('lab_userRoles');
				localStorage.setItem('lab_logged', 'no');
				this.setState({ isRedirect: true });
			}
		});
	}

	getActiveUrl(url) {
		var s = url.split("/");
		return s[1];
	}

	loadAcYears(e) {
		this.setState({ showLoader: true });
		Reqst.axGet('acyear/aylist/' + this.state.companyId).then((res) => {
			if (res['data'].status == '1') {
				this.setState({ showLoader: false, acYearList: res['data'].data });
			}
			else {
				this.setState({ showLoader: false });
			}
		});
	}

	changeAcYearClick(id, name, e) {
		Sanitize.setStorage('AcYear_id', id);
		Sanitize.setStorage('AcYear_name', name);
		this.setState({ showAcYearModal: false });
		//console.log(window.location.href);
		window.location.reload();
	}

	render() {

		if (localStorage.getItem('lab_logged') != 'yes') {
			return (<Redirect to='/' />);
		}
		else if (this.state.isRedirect) {
			return (<Redirect to='/' />);
		}
		else {

			let activeMenu = window.location.hash.split('/')[1];
			let _activeMenu = '/' + window.location.hash.split('/');
			_activeMenu = _activeMenu.replace(/,/g, '/').slice(2);

			return (
				<div>
					<Navbar bg="primary_2" expand="lg" fixed="top" >
						<Navbar.Brand href="javascript:;">
							<img src={LOGO} width="40" style={{ marginTop: -10 }} />
						</Navbar.Brand>
						<Navbar.Toggle aria-controls="basic-navbar-nav" />
						<Navbar.Collapse id="basic-navbar-nav">
							<Nav className="mr-auto">
								<RenderMenu />
							</Nav>

							<Nav>
								{/*<Nav className="pull-right  my-nav-right" >
									<NavItem style={{ marginTop: "8px" }}>
										<button style={acYearBtn} onClick={() => { this.setState({ showAcYearModal: true }) }} >{Sanitize.getData('AcYear_name')}</button>
									</NavItem>
								</Nav>*/}
								<NavDropdown title={Sanitize.getData('labUser_name')} id="dropdown-menu-align-right" alignRight >
									<NavDropdown.Item href="#action/3.1">My Profile</NavDropdown.Item>
									<NavDropdown.Item href="#action/3.2">Settings</NavDropdown.Item>
									<NavDropdown.Divider />
									<NavDropdown.Item href="javascript:;" onClick={this.handleLogout} >Logout</NavDropdown.Item>
								</NavDropdown>
								<Nav.Link eventKey={2} href="javascript:;" onClick={this.handleLogout} >
									<i className="fa fa-sign-out" style={{ fontSize: '15px' }} ></i>
								</Nav.Link>
							</Nav>

						</Navbar.Collapse>
					</Navbar>

					<Modal show={this.state.showAcYearModal} onHide={() => { this.setState({ showAcYearModal: false }) }} onEntered={this.loadAcYears.bind(this)} >
						<Modal.Body style={{ border: '4px solid #aaabad', padding: '20px' }} >
							<div>
								<h4 className="text-center" style={{ borderBottom: '1px solid #ececec', paddingBottom: '10px' }} >Select Academic Year</h4>
								<table width="100%" align="center" >
									{
										this.state.acYearList.map((item, i) => {
											return <tr key={i} style={{ borderBottom: '1px solid #adadad' }} >
												<td style={{ padding: '10px' }} >
													{item.name}  {item.description}
												</td>
												<td style={{ padding: '10px' }} width="80" align="center" >
													<button className="btn btn-success btn-sm bnt-xs " onClick={this.changeAcYearClick.bind(this, item.id, item.name)} >
														Go
											</button>
												</td>
											</tr>;
										})
									}
								</table>
							</div>
						</Modal.Body>
					</Modal>
				</div>
			);
		}
	}

}
export default Header;

